const defaultInfoFormatterPage = (currentPage, pageCount) => {
    if (!pageCount)
        return `Página ${currentPage}`;
    return `Página ${currentPage} de ${pageCount}`;
};

export { defaultInfoFormatterPage };
